import React from 'react';
import { Inbox } from 'lucide-react';

export default function EmptyState({ message = 'Nenhum registro encontrado', hint, icon: Icon = Inbox, className = '' }) {
  return (
    <div className={`flex flex-col items-center justify-center py-12 text-center ${className}`}>
      <div className="bg-slate-100 p-3 rounded-full mb-3">
        <Icon size={24} className="text-slate-400" />
      </div>
      <div className="text-sm font-medium text-slate-700">{message}</div>
      {hint && <div className="text-xs text-slate-500 mt-1 max-w-sm">{hint}</div>}
    </div>
  );
}
